!function () {
  "use strict";

  if (customElements.get("product-notification")) return;

  customElements.define("product-notification", class extends HTMLElement {
    constructor() {
      super();
      this.notificationForm = this.querySelector("[data-notification-form]");
      this.preventSubmit = true;

      // Fix 1: Null-safety guards — element MUST be inside a <dialog> with a close button
      this.popup = this.closest("dialog");
      if (!this.popup) {
        console.warn("product-notification: must be inside a <dialog> element.");
        return;
      }
      this.popupClose = this.popup.querySelector("[data-popup-close]");
      if (!this.popupClose) {
        console.warn("product-notification: no [data-popup-close] button found in dialog.");
        return;
      }
    }

    connectedCallback() {
      if (!this.popup || !this.popupClose || !this.notificationForm) return;

      // Fix 4: Defer checkState so child elements are fully parsed & upgraded
      requestAnimationFrame(() => this.checkState());

      // Stop clicks/mouse events inside the form from bubbling to the dialog backdrop
      ["click", "mousedown", "pointerdown"].forEach(evt => {
        this.notificationForm.addEventListener(evt, e => e.stopPropagation());
      });

      this.notificationForm.querySelectorAll("input, button").forEach(el => {
        ["click", "mousedown"].forEach(evt => {
          el.addEventListener(evt, e => e.stopPropagation());
        });
      });

      // Fix 5: Store named handler references so they can be removed on disconnect
      this._submitHandler = e => this.notificationSubmitEvent(e);
      this._closeHandler = () => this.removeStorage();

      this.notificationForm.addEventListener("submit", this._submitHandler);
      this.popupClose.addEventListener("click", this._closeHandler);
    }

    // Fix 5: Clean up listeners when element is removed from the DOM
    disconnectedCallback() {
      this.notificationForm?.removeEventListener("submit", this._submitHandler);
      this.popupClose?.removeEventListener("click", this._closeHandler);
    }

    checkState() {
      if (
        !window.notificationPopupHandled &&
        window.location.search.indexOf("?contact_posted=true") !== -1 &&
        window.sessionStorage.getItem("notification_form_id") === this.notificationForm.id
      ) {
        window.notificationPopupHandled = true;

        const heading = this.querySelector("[data-product-notification-heading]");
        if (heading) heading.classList.add("hidden");

        this.closest("popup-component")?.classList.add("has-success");

        // Fix 2: Open the dialog FIRST, then remove inert
        if (typeof this.popup.showModal === "function") {
          this.popup.showModal();
        } else {
          this.popup.setAttribute("open", "");
        }
        this.popup.removeAttribute("inert");

        window.sessionStorage.removeItem("notification_form_id");
      }
    }

    notificationSubmitEvent(e) {
      // Fix 3: Flip flag BEFORE calling submit() to prevent re-entry / double submission
      if (!this.preventSubmit) return;
      e.preventDefault();
      this.preventSubmit = false;
      this.removeStorage();
      this.writeStorage();
      this.notificationForm.submit();
    }

    writeStorage() {
      if (typeof window.sessionStorage !== "undefined") {
        window.sessionStorage.setItem("notification_form_id", this.notificationForm.id);
      }
    }

    removeStorage() {
      window.sessionStorage.removeItem("notification_form_id");
    }
  });
}();